import React from 'react';
import App from './App';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import './assets/css/bootstrap.min.css';
import "./assets/css/animate.css";
import "./assets/css/icons.css";
import "./assets/css/style.css";
import '../node_modules/bootstrap/dist/js/bootstrap'
import SimpleReactLightbox from 'simple-react-lightbox';

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

ReactDOM.render(
    <>
    <HelmetProvider>
    <SimpleReactLightbox>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      </SimpleReactLightbox>
    </HelmetProvider>
    </>,
    document.getElementById('root')
  );
reportWebVitals();
